import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

/**
 * EmptyState — "there is nothing here", which is a normal state, not a failure.
 * Distinct from ErrorState: empty means the request succeeded and returned nothing.
 */
const EmptyState = ({ title = 'Nothing here yet', message, icon, action, sx = {} }) => (
    <Stack alignItems="center" justifyContent="center" spacing={1} sx={{ py: 6, px: 2, textAlign: 'center', ...sx }}>
        <Box sx={{ color: 'text.disabled', display: 'flex' }}>
            {icon || <InboxOutlinedIcon sx={{ fontSize: 44 }} />}
        </Box>
        <Typography variant="subtitle1" fontWeight={600}>
            {title}
        </Typography>
        {message && (
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
                {message}
            </Typography>
        )}
        {action && <Box sx={{ pt: 1 }}>{action}</Box>}
    </Stack>
);

export default EmptyState;
